import React from "react";

// Chakra imports
import { Flex, useColorModeValue, Box } from "@chakra-ui/react";

// Custom components
import { MainLogo } from "components/icons/Icons";
import { HSeparator } from "components/separator/Separator";
import { useNavigate } from "react-router-dom";

export function SidebarBrand() {
  const navigate = useNavigate();
  const brandColor = useColorModeValue(
    "rgba(245, 125, 54, 0.8)",
    "rgba(245, 125, 54, 0.8)",
  );

  return (
    <Flex
      align="center"
      direction="column"
      justifyContent="flex-start"
      position={"relative"}
      pt="5px"
      pb="12px"
      onClick={() => navigate("/admin/dashboard")}
      cursor="pointer"
      transition="all 0.3s ease"
      _hover={{
        transform: "translateY(-3px)",
      }}
      role="group"
    >
      <Box
        p={2}
        borderRadius="xl"
        bg="rgba(245, 125, 54, 0.05)"
        transition="all 0.3s ease"
        transform="scale(0.85)"
        position="relative"
        _groupHover={{
          bg: "rgba(245, 125, 54, 0.1)",
          boxShadow: "0 5px 15px rgba(245, 125, 54, 0.2)",
        }}
        _before={{
          content: '""',
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          borderRadius: "xl",
          background:
            "linear-gradient(45deg, rgba(245, 125, 54, 0.2) 0%, rgba(245, 125, 54, 0) 70%)",
          zIndex: 0,
          pointerEvents: "none",
        }}
      >
        <MainLogo width="100%" padding="16px" />
      </Box>
      <HSeparator
        mt="10px"
        mb="12px"
        borderColor="rgba(245, 125, 54, 0.3)"
        borderWidth="1px"
        width="80%"
        borderRadius="full"
        boxShadow="0 1px 2px rgba(245, 125, 54, 0.1)"
        opacity="0.8"
        _groupHover={{
          width: "90%",
          borderColor: "rgba(245, 125, 54, 0.5)",
          boxShadow: "0 1px 4px rgba(245, 125, 54, 0.2)",
        }}
        transition="all 0.3s ease"
      />
    </Flex>
  );
}

export default SidebarBrand;
